<div class="file-list-item-wrapper">
  <div class="file-list-item" [class.disabled]="disabled()" [class.error]="hasErrors()" [class.thumbnail]="thumbnail()">
    @if (thumbnail()) {
      <!-- ws wants me to use `ngSrc` here but it would result in a runtime error because `ngSrc` doesn't work with blobs or base64 strings -->
      <img [src]="URL.createObjectURL(file())"
           width="40"
           height="40"
           alt="sponsor logo thumbnail"
           i18n-alt>
    }
    <div class="file-list-item-right">
      <div class="file-list-item-text">
        <div class="file-name">
          {{ file().name }}
        </div>
        <div class="file-size">
          {{ file() | getFileSize }}
        </div>
      </div>
      <div class="file-actions" [hidden]="disabled()">
        <lib-button
          [hidden]="hideReplace()"
          [type]="ButtonType.tertiary"
          [size]="InputSize.small"
          (buttonClick)="replaceClicked.emit(file())" i18n>
          Replace File
        </lib-button>
        <div class="d-flex align-items-center gap-2">
          <mat-icon
            class="view-icon"
            [hidden]="hideView()"
            [svgIcon]="'view'"
            (click)="previewClicked.emit(file())">
          </mat-icon>
          <mat-icon
            class="delete-icon"
            [svgIcon]="'delete'"
            [hidden]="hideDelete()"
            (click)="removeClicked.emit(file())">
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  @if (hasErrors()) {
    <lib-form-error [errors]="validationErrors()"></lib-form-error>
  }
</div>

